import React, {createContext, useState} from 'react'
import {PICK_VIEWS} from "../constants/Constants"

export const PickViewSelectorContext = createContext();

export const PickViewSelectorContextProvider = (props) => {
    const initialState = PICK_VIEWS.ROUTE_VIEW
    const [viewState, setViewState] = useState(initialState);

    return (
        <PickViewSelectorContext.Provider value={{viewState, setViewState}}>
            {props.children}
        </PickViewSelectorContext.Provider>
    )
}



// WEBPACK FOOTER //
// ./src/components/pickStatus/context/PickViewSelectorContext.js